var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose56Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 58.997,
    viewBox: "0 0 59 58.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1047",
    x: 0,
    y: 0,
    width: 59,
    height: 58.997,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_16_2",
    "data-name": "Component 16 \\u2013 2",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.5, -0.5)",
    filter: "url(#Rectangle_1047)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047-2",
    "data-name": "Rectangle 1047",
    width: 56,
    height: 55.997,
    rx: 27.998,
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "close-24px",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M18,6h0a.967.967,0,0,0-1.4,0L12,10.6,7.4,6A.967.967,0,0,0,6,6H6A.967.967,0,0,0,6,7.4L10.6,12,6,16.6A.967.967,0,0,0,6,18H6a.967.967,0,0,0,1.4,0L12,13.4,16.6,18A.967.967,0,0,0,18,18h0a.967.967,0,0,0,0-1.4L13.4,12,18,7.4A.967.967,0,0,0,18,6Z",
    transform: "translate(0 0)",
    fill: "#111"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose56Px);
export default __webpack_public_path__ + "static/media/close-56px.5d7456b4b7998371ff059a48026597f3.svg";
export { ForwardRef as ReactComponent };